module.exports = __webpack_public_path__ + "static/scale-model-of-arabia-steamboat-museum-in-kansas-city-missouri-47689b19a3def32878c5cf8e1be2b139.png";